/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var moyaFetch = MoyaContainer.get('core.fetch');
    MoyaComponents.register('site.newsheadlinesbox', function (el) {
        var filterButtons = el.querySelectorAll('.filter-items > a');
        function removeSelected(buttons) {
            buttons.forEach(function (button) {
                button.classList.remove('selected');
            });
        }
        filterButtons.forEach(function (button) {
            util.delegate(button, 'click', 'a', function (e) {
                e.preventDefault();
                removeSelected(filterButtons);
                button.classList.add('selected');
                new Promise(function (resolve) {
                    moyaFetch.fetchHtml(button.href, 'GET').then(function (res) {
                        resolve(res);
                        var newCardElements = res.querySelectorAll('.entries  > .news__item:nth-child(1), .entries > .news__item:nth-child(2), .entries > .news__item:nth-child(3), .entries > .news__item:nth-child(4), .entries > .news__item:nth-child(5), .entries > .news__item:nth-child(6), .entries > .news__item:nth-child(7), .entries > .news__item:nth-child(8)');
                        var listElement = document.querySelector('.entries');
                        if (listElement) {
                            listElement.innerHTML = '';
                            newCardElements.forEach(function (el) {
                                listElement.appendChild(el);
                            });
                        }
                    });
                });
            });
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
